import { InitialState, NavigationState } from '@react-navigation/native';

export function nameOfCurrentRoute(
  group: string,
  state: NavigationState,
): string {
  let current: InitialState | undefined = state;
  let prefix = group;

  while (current?.routes[current.index ?? 0].state != null) {
    const parent: any = current.routes[current.index ?? 0];
    prefix = prefix + parent.name + '/';
    current = parent.state;
  }

  const route = current?.routes[current?.index ?? 0];
  if (route == null) {
    return prefix + 'init';
  }
  return prefix + route?.name;
}

export function currentRouteFromState(group: string, state: NavigationState) {
  let current: InitialState | undefined = state;
  let prefix = group;

  while (current?.routes?.[current.index ?? 0]?.state != null) {
    const parent: any = current.routes[current.index ?? 0];
    prefix = prefix + parent.name + '/';
    current = parent.state;
  }

  const route = current?.routes?.[current?.index ?? 0];
  if (route == null) {
    return [prefix + 'init', null] as const;
  }

  return [prefix + route.name, route] as const;
}
